import React from "react";

import { createRoot } from "react-dom/client";

import { BundledStyles } from "heat-next";

import App from "@/app";

import "./index.css";
import "./styles/main.css";
import "./styles/calendar.css";

const container = document.getElementById("root"); //to get the root element

const cssStr = (BundledStyles as string[]).filter((str) => str.indexOf(";") !== 0).join("\n");

document.body.appendChild(
    (() => {
        const style = document.createElement("style");
        // Scale rem values down by 0.625x
        const scaledCssStr = cssStr.replace(/(\d*\.?\d+)rem/g, (match, value) => {
            return parseFloat(value) * 0.625 + "rem";
        });
        style.innerHTML = scaledCssStr + "}";
        style.id = "heya";

        return style;
    })(),
);

if (container) {
    const root = createRoot(container); //create a root using createRoot

    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
    );
}
